import { useState, useEffect } from 'react';
import { Check } from 'lucide-react';
import { Modal } from '../../../components/ui/Modal';

const STATUS_FILTER_OPTIONS  = [
  { key: 'active',   label: 'Actif'    },
  { key: 'inactive', label: 'Inactif'  },
];
const INVOICE_FILTER_OPTIONS = [
  { key: 'paid',    label: 'Encaissé'  },
  { key: 'overdue', label: 'En retard' },
];

function CheckOption({ field, opt, draft, onToggle }) {
  const checked = draft[field].includes(opt.key);
  return (
    <label className={`flex items-center gap-2 px-3 py-2 rounded-lg border cursor-pointer text-[12px] font-medium transition select-none ${
      checked
        ? 'border-primary bg-primary/5 text-primary'
        : 'border-slate-200 text-slate-600 hover:border-slate-300 hover:bg-slate-50'
    }`}>
      <input type="checkbox" checked={checked} onChange={() => onToggle(field, opt.key)} className="sr-only" />
      <span className={`w-3.5 h-3.5 rounded flex items-center justify-center border flex-shrink-0 ${
        checked ? 'bg-primary border-primary' : 'border-slate-300'
      }`}>
        {checked && <Check size={9} strokeWidth={3} className="text-white" />}
      </span>
      {opt.label}
    </label>
  );
}

export function ClientFilterModal({ open, onClose, values, onApply, onReset }) {
  const [draft, setDraft] = useState(values);

  useEffect(() => {
    if (open) setDraft(values);
  }, [open, values]);

  function toggle(field, key) {
    setDraft((d) => ({
      ...d,
      [field]: d[field].includes(key)
        ? d[field].filter((x) => x !== key)
        : [...d[field], key],
    }));
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Filtres avancés"
      size="sm"
      footer={
        <>
          <button
            onClick={() => { onReset(); onClose(); }}
            className="h-8 px-3 rounded-lg text-[12px] font-medium text-slate-600 hover:bg-slate-100 transition"
          >
            Réinitialiser
          </button>
          <button
            onClick={() => { onApply(draft); onClose(); }}
            className="h-8 px-4 rounded-lg bg-primary text-white text-[12px] font-medium hover:opacity-90 transition"
          >
            Appliquer
          </button>
        </>
      }
    >
      <div className="space-y-2">
        <p className="text-[11px] font-semibold text-slate-500 uppercase tracking-wide">Statut</p>
        <div className="grid grid-cols-2 gap-1.5">
          {STATUS_FILTER_OPTIONS.map((opt) => (
            <CheckOption key={opt.key} field="status" opt={opt} draft={draft} onToggle={toggle} />
          ))}
        </div>
      </div>
      <div className="space-y-2">
        <p className="text-[11px] font-semibold text-slate-500 uppercase tracking-wide">Facturation</p>
        <div className="grid grid-cols-2 gap-1.5">
          {INVOICE_FILTER_OPTIONS.map((opt) => (
            <CheckOption key={opt.key} field="invoices" opt={opt} draft={draft} onToggle={toggle} />
          ))}
        </div>
      </div>
    </Modal>
  );
}
